import { render, staticRenderFns } from "./OrderShipList.vue?vue&type=template&id=2bcbea4e&"
import script from "./OrderShipList.vue?vue&type=script&lang=js&"
export * from "./OrderShipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports